import { Component } from '@angular/core';
import { Consent, CreatePerson, Person } from '@qivos/core-api';
import {
  CreatePersonData,
  OtpValidationFacadeService,
  PersonDetailsFacadeService,
  UpdatePersonData,
} from '@qivos/qivoscloud-ion-components';
import { OtpValidation } from '@qivos/qivoscloud-ion-components/lib/models/otp-validation.model';
import { PersonDetailsForm } from '@qivos/qivoscloud-ion-components/lib/models/person-details.model';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor(
    public facade: OtpValidationFacadeService,
    public PersonFacade: PersonDetailsFacadeService,
  ) {}

  person: Person = {
    emailList: [],
    addressList: [],
    consentList: [],
    telephoneList: [],
    loyaltyMembershipData: [],
  };
  consentList: Consent[] = [];

  personDetails: PersonDetailsForm = {
    mobileNumber: {
      rendered: false,
      required: false,
      label: '',
      placeholder: '',
      value: '',
      validation: /^69[0-9]*\d*$/,
      message: '',
      disabled: true,
    },
    gender: {
      rendered: true,
      required: true,
      label: 'Φύλο',
      selectedGender: { Label: '', Name: '', Value: '' },
      values: [
        {
          Label: 'Άντρας',
          Name: '',
          Value: 'MALE',
        },
        {
          Label: 'Γυναίκα',
          Name: '',
          Value: 'FEMALE',
        },
      ],
    },
    firstName: {
      rendered: true,
      required: true,
      disabled: false,
      label: 'Όνομα',
      placeholder: '',
      value: '',
      validation: /^[α-ωίϊΐόάέύϋΰήώΑ-ΩΆΈΊΌΎΏΉa-zA-Zs.-]+$/,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    lastName: {
      rendered: true,
      required: true,
      disabled: false,
      label: 'Επώνυμο',
      placeholder: '',
      value: '',
      validation: /^[α-ωίϊΐόάέύϋΰήώΑ-ΩΆΈΊΌΎΏΉa-zA-Zs.-]+$/,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    email: {
      rendered: true,
      required: false,
      label: 'Email',
      placeholder: 'Πληκτρολόγησε το email σου',
      value: '',
      validation:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@[A-Za-z0-9.-]{2,})+\.[A-Za-z]{2,}/,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    region: {
      rendered: true,
      required: false,
      label: 'Νομός',
      placeholder: '',
      value: '',
      message: '',
    },
    town: {
      rendered: true,
      required: false,
      label: 'Πόλη',
      placeholder: '',
      value: '',
    },
    addressLine: {
      rendered: false,
      required: false,
      disabled: false,
      label: 'Διεύθυνση',
      placeholder: 'Πληκτρολόγησε τη διεύθυνσή σου',
      value: '',
      validation: / /,
      message: '',
    },
    zipCode: {
      rendered: true,
      required: false,
      label: 'ΤΚ',
      placeholder: '',
      value: '',
      validation: /^[0-9]{5}$/,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    dateOfBirth: {
      rendered: true,
      required: false,
      label: 'Ημερομηνία γέννησης',
      placeholder: 'Ημερομηνία',
      datePickerDoneButtonLabel: 'OK',
      datePickerCancelButtonLabel: 'Άκυρο',
      datePickerLocale: 'el-GR',
      value: '',
      minValue: 18,
      maxValue: 0,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    nameDate: {
      rendered: true,
      required: false,
      nameDateDayPlaceholder: 'Ημέρα',
      nameDateMonthPlaceholder: 'Μήνας',
      nameDateLabel: 'Ημερομηνία Ονομαστικής Εορτής',
      nameDateDayValue: '',
      nameDateDayLabel: 'Ημέρα',
      nameDateMonthValue: '',
      nameDateMonthLabel: 'Μήνας',
      errorMessage: 'Πρέπει να επιλέξεις πρώτα μήνα',
    },
    singleConsent: {
      rendered: false,
      required: false,
      label: 'Επιλέξτε πώς θέλετε να λαμβάνετε τα νέα μας',
    },
    consents: [],
    multiConsent: {
      rendered: false,
      required: false,
      label: '',
    },
    allConsent: {
      rendered: false,
      label: '',
      value: false,
    },
    isPersonalized: true,
    flowExecution: true,
    flowExecutionId: 'FAIS_LMF_TRIGGER_FROM_PERSONALIZED_FORM',
    flowExecutionSubject: 'LOYALTY_MEMBER',
    token: '',
  };

  otpValidationConfig: OtpValidation = {
    mobileNumber: {
      rendered: false,
      required: false,
      label: '',
      placeholder: 'Mobile Number',
      value: '',
      validation: /^69[0-9]*\d*$/,
      message: '',
      disabled: false,
    },
    otp: {
      rendered: false,
      required: false,
      label: '',
      placeholder: 'Otp',
      value: '',
      validation: /^\d{6}$/,
      message: 'Το OTP δεν είναι σωστό',
    },
    account: 'demo',
    countryCode: 'gr',
    otpProfileCode: 'REFER_A_FRIEND_OTP',
    schemaCode: '1111',
    type: 'CUSTOMER_REGISTRATION',
    languageCode: 'el',
    sendOtpTextBtn: 'Send Otp',
    validateOtpTextBtn: 'Submit',
    btnTextColor: 'white',
    btnColor: 'gray',
    jwtToken: '',
    userIsRegisteredMessage: '',
  };

  submit() {
    const addressList: any[] = [
      {
        countryCode: this.facade.countryCode ? this.facade.countryCode : 'gr',
        addressLine2: '',
        town: this.PersonFacade.selectedTown,
        addressType: 'PRIMARY_PERSON_ADDRESS',
      },
    ];

    if (this.PersonFacade.selectedTown)
      addressList[0].town = this.PersonFacade.selectedTown;
    if (this.PersonFacade.zipCode)
      addressList[0].postCode = this.PersonFacade.zipCode;
    if (this.PersonFacade.selectedRegionCode)
      addressList[0].regionCode = this.PersonFacade.selectedRegionCode;

    if (this.PersonFacade.isPersonalized) {
      const personUpdate: Person = this.updatePersonDTO(addressList);
      this.facade.dispatch(
        UpdatePersonData({
          person: personUpdate,
        }),
      );
    } else {
      const personCreate: CreatePerson.CreatePersonDTO =
        this.createPersonDTO(addressList);
      this.facade.dispatch(
        CreatePersonData({
          person: personCreate,
        }),
      );
    }
  }

  createPersonDTO(addressList: any[]): CreatePerson.CreatePersonDTO {
    const person: CreatePerson.CreatePersonDTO = {
      firstName: this.PersonFacade.firstName,
      lastName: this.PersonFacade.lastName,
      languageCode: this.facade.languageCode,
      gender: this.PersonFacade.gender.Value,
      dateOfBirth: this.PersonFacade.dateOfBirth,
      nameDayDay: this.PersonFacade.nameDateDay,
      nameDayMonth: this.PersonFacade.nameDateMonth,
      telephoneList: [
        {
          telephoneNumber: this.facade.mobileNumber,
          countryCode: this.facade.countryCode,
          telephoneType: 'MOBILE',
          isPrimary: true,
        },
      ],
      loyaltyMembershipData: [
        {
          schemaCode: '1111',
          registrationCountryCode: this.facade.countryCode,
          category: 'Normal',
          registrationSource: 'REFERRAL',
          registrationStoreCode: '1000',
          loyaltyCardData: {
            type: 'Permanent',
          },
          attributes: [],
        },
      ],
      consentList: this.consentList,
      addressList: addressList,
      emailList: !!this.PersonFacade.email
        ? [
            {
              emailAddress: this.PersonFacade.email,
              isPrimary: true,
              attributes: [],
            },
          ]
        : [],
    };

    //     this.PersonFacade.multiConsentsStatus
    //       ? this.PersonFacade.consents.forEach((consent) =>
    //           person.consentList?.push({
    //             name: consent.name,
    //             flag: true,
    //             metadata: [{ key: 'Retail', value: 'OFFLINE' }],
    //           } as Consent),
    //         )
    //       : this.PersonFacade.consents.forEach((consent) =>
    //           person.consentList?.push({
    //             name: consent.name,
    //             flag: consent.flag,
    //             metadata: [{ key: 'Retail', value: 'OFFLINE' }],
    //           } as Consent),
    //         );

    return person;
  }

  updatePersonDTO(addressList: any[]): Person {
    const person: Person = {
      firstName: this.PersonFacade.firstName,
      lastName: this.PersonFacade.lastName,
      gender: this.PersonFacade.gender.Value as 'UNKNOWN' | 'MALE' | 'FEMALE',
      dateOfBirth: this.PersonFacade.dateOfBirth,
      nameDayDay: this.PersonFacade.nameDateDay,
      nameDayMonth: this.PersonFacade.nameDateMonth,
      telephoneList: [
        {
          telephoneNumber: this.facade.mobileNumber,
          countryCode: this.facade.countryCode ? this.facade.countryCode : 'gr',
          telephoneType: 'MOBILE',
          isPrimary: true,
          QCCode: 'string',
        },
      ],
      consentList: this.consentList,
      addressList:
        this.PersonFacade.selectedTown ||
        this.PersonFacade.zipCode ||
        this.PersonFacade.selectedRegionCode
          ? addressList
          : undefined,
      emailList: !!this.PersonFacade.email
        ? [
            {
              emailAddress: this.PersonFacade.email,
              isPrimary: true,
              attributes: [],
            },
          ]
        : this.PersonFacade.existingPerson?.emailList?.map((email) => {
            const { QCCode, emailAddress, isPrimary, ...rest } = email;
            return {
              QCCode: QCCode,
              action: 'DELETE',
              emailAddress: emailAddress,
              isPrimary: isPrimary,
            };
          }),
      loyaltyMembershipData: [
        {
          schemaCode: '1111',
          registrationCountryCode: this.facade.countryCode,
          category: 'Normal',
          registrationSource: 'REFERRAL',
          registrationStoreCode: '1000',
          loyaltyCardData: {
            type: 'Permanent',
          },
          attributes: [],
        },
      ],
    };

    //     this.PersonFacade.multiConsentsStatus
    //       ? this.PersonFacade.consents.forEach((consent) =>
    //           person.consentList?.push({
    //             name: consent.name,
    //             flag: true,
    //             metadata: [{ key: 'Retail', value: 'OFFLINE' }],
    //           } as Consent),
    //         )
    //       : this.PersonFacade.consents.forEach((consent) =>
    //           person.consentList?.push({
    //             name: consent.name,
    //             flag: consent.flag,
    //             metadata: [{ key: 'Retail', value: 'OFFLINE' }],
    //           } as Consent),
    //         );

    return person;
  }
}
